import React, { Component, Fragment } from "react";

import * as PropTypes from "prop-types";

import { Button, Modal, Typography } from "antd";
const { Text } = Typography;

import {
	UIFormSection,
	UIInfoBanner,
	UIPageListing,
} from "../../../components";

import { employeesAdressesService } from "../../../redux/services";

import ModalEdit from "./edit";
import ModalCreate from "./create";
import ModalView from "./view";

const config = {
	searchPlaceholder: "Buscar Cidade",
	permissionPrefix: "customers",
};

class Index extends Component {
	static propTypes = {
		showOnly: PropTypes.bool,
	}

	constructor(props) {
		super(props);

		this.state = {
			listType: "list",
			dataAll: [],
			data: [],
			search: '',
			// Owner item
			ownerItem: {},
			// Actions
			editModalVisible: false,
			viewModalVisible: false,
		};
	}

	init = (ownerItem) => {
		this.setState({
			ownerItem: ownerItem,
			// dataAll: ownerItem.enderecos,
			// data: ownerItem.enderecos,

		});

		setTimeout(() => {
			this.fetchGetAll();
		}, 10)
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({ uuid }) => {
		this.setState({ editModalVisible: true });

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	/**
	 * View
	 *
	 * @param uuid
	 */
	viewOpen = ({ uuid }) => {
		this.setState({ viewModalVisible: true });

		// On open screen
		this.viewScreen.onOpen(uuid);
	};

	viewOnClose = () => {
		this.setState({ viewModalVisible: false });
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({ uuid }) => {
		Modal.confirm({
			title: "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText: "Excluir",
			autoFocusButton: null,
			onOk: () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return employeesAdressesService.destroy(this.state.ownerItem.uuid, uuid)
			.then((response) => {
				// Fecth all
				this.fetchGetAll();
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	editOnComplete = () => {
		this.setState({ editModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	columns = () => [
		{
			title: "Logradouro",
			render: (item) => (
				<div className="cell-icon-info">
					<div className="cell-icon-info-icon">
						<i className="fal fa-map-marker-alt" />
					</div>
					<div className="cell-icon-info-text">
						<Text ellipsis={{ tooltip: `${item.logradouro}, ${item.numero}` }} className="cell-icon-info-title">{item.logradouro}, {item.numero}</Text>
						<Text type="secondary" ellipsis={{ tooltip: `${item.bairro} - CEP: ${item.cep}` }} className="cell-icon-info-subtitle">{item.bairro} - CEP: {item.cep}</Text>
					</div>
				</div>
			),
		},
		{
			title: "Cidade",
			render: (item) => (item.cidade?.name + " - " + item.cidade?.estado.abbr) ?? '-',
		},
		{
			title: "Endereço principal",
			className: "active no-ellipsis",
			width: 150,
			render: (item) => (
				<span className={`status-tag ${item.endereco_principal ? "status-tag-success" : "status-tag-error"}`}>
					<i className="status-tag-dot" />
					{item.endereco_principal ? "Sim" : "Não"}
				</span>
			),
		},
		{
			title: "Ações",
			className: "actions no-ellipsis",
			width: 150,
			render: (item) => (
				<div className="table-row-actions">
					{this.props.showOnly ? (
						<Button className="table-row-action-btn" icon={<i className="fal fa-eye" />} onClick={() => this.viewOpen(item)} />
					) : (
						<>
							<Button className="table-row-action-btn" icon={<i className="fal fa-pen" />} onClick={() => this.editOpen(item)} />
							<Button className="table-row-action-btn table-row-action-btn-danger" icon={<i className="fal fa-trash" />} onClick={() => this.deleteConfirm(item)} />
						</>
					)}
				</div>
			),
		},
	];

	fetchGetAll = () => {
		this.setState({
			isLoading: true,
		});

		employeesAdressesService.getAll({ client_uuid: this.state.ownerItem.uuid })
			.then((response) => {
				this.setState(state => ({
					isLoading: false,
					data: response.data.data,
					dataAll: response.data.data,
				}));
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	searchItems = () => {
		const { search } = this.state;
		const newData = [...this.state.dataAll];

		this.setState({
			data: search ? newData.filter((item) => item.cidade.name.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item.cidade.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) : newData,
		});
	};

	editOnClose = () => {
		this.setState({ editModalVisible: false });
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.searchItems();
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if (!e.hasOwnProperty("type")) {
			const { search } = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if (search) {
					this.searchItems();
				}
			});
		}
	};


	render() {
		const { showOnly } = this.props;

		return (
			<Fragment>
				<UIFormSection
					icon={<i className="fal fa-map-marker-alt" />}
					title="Endereços"
					description={showOnly ? "Visualize os endereços cadastrados do funcionário." : "Cadastre os endereços do funcionário."}
					extra={!showOnly && (
						<Button type="default" className="action-btn-secondary" icon={<i className="far fa-plus" />} onClick={this.createOpen}>
							Adicionar endereço
						</Button>
					)}
				>
					<UIPageListing
						listType={this.state.listType}
						showListTypeChange={false}
						enablePagination={false}
						enableSearch={false}
						data={this.state.data}
						columns={this.columns()}
						emptyIcon={<i className="fal fa-map-marker-alt" />}
						emptyTitle="Nenhum endereço cadastrado"
						emptyDescription={showOnly ? "Este funcionário não possui endereços cadastrados." : "Adicione os endereços do funcionário."}
						emptyAction={!showOnly && (
							<Button type="primary" icon={<i className="far fa-plus" />} onClick={this.createOpen}>
								Adicionar endereço
							</Button>
						)}
					/>
				</UIFormSection>
				{!showOnly && (
					<UIInfoBanner
						icon={<i className="fal fa-info-circle" />}
						title="Sobre os endereços"
						description="O primeiro endereço cadastrado é definido como principal. Para trocar, edite outro endereço e marque-o como principal."
					/>
				)}
				<ModalEdit
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalView
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.viewScreen = el}
					visible={this.state.viewModalVisible}
					// onComplete={this.viewOnComplete}
					onClose={this.viewOnClose}
				/>
				<ModalCreate
					empresa_id={this.state.ownerItem.contrato && this.state.ownerItem.contrato?.empresa_id}
					adressesCount={this.state.dataAll.length}
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
			</Fragment>
		)
	}
}

export default Index;
